import { FAQItem } from '@/types'

/**
 * Frequently asked questions
 */
export const faqItems: FAQItem[] = [
  {
    id: 'faq-1',
    question: 'How long does it take to build a website?',
    answer: 'Most websites are completed within 2-4 weeks, depending on the complexity and package chosen. We work efficiently to get your site live quickly while maintaining high quality standards.',
  },
  {
    id: 'faq-2',
    question: 'Can you redesign my existing plumbing website?',
    answer: "Absolutely! We can redesign your existing website to make it more modern, mobile-friendly, and conversion-focused. We'll work with any existing content you want to keep while improving the design and functionality.",
  },
  {
    id: 'faq-3',
    question: 'Will the website help me get more leads?',
    answer: 'Yes. Our websites are specifically designed for lead generation with clear calls-to-action, contact forms, click-to-call buttons, and trust-building elements. Combined with local SEO, your site will attract more qualified visitors who convert into customers.',
  },
  {
    id: 'faq-4',
    question: 'Do you offer SEO services?',
    answer: 'Yes, all our packages include SEO setup. Our Growth and Lead Generation packages include comprehensive local SEO strategies to help you rank higher in local search results and attract more customers in your service area.',
  },
  {
    id: 'faq-5',
    question: 'Can you manage updates after the site is live?',
    answer: 'Yes! All packages include support for a specified period, and we offer ongoing maintenance plans for long-term website management, updates, security, and technical support.',
  },
  {
    id: 'faq-6',
    question: 'What if I need changes after the site is live?',
    answer: 'We include support with every package, and minor updates are part of that support. For larger changes or additions, we provide affordable hourly rates or can create a custom maintenance plan.',
  },
  {
    id: 'faq-7',
    question: 'Do you work with plumbing companies outside my area?',
    answer: 'Yes, we work with plumbing companies across the United States. All communication is handled remotely via phone, email, and video calls, making it easy to collaborate regardless of location.',
  },
  {
    id: 'faq-8',
    question: 'What makes your websites different?',
    answer: 'We specialize in websites for service businesses like plumbers. We understand your industry, your customers, and what drives conversions. Our sites are built for practical business results, not just aesthetics.',
  },
]
